import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { Box, Menu, MenuItem, SxProps, Theme } from '@mui/material';
import propTypes from 'prop-types';
import { FC, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { Link } from 'react-router-dom';
import { AuthenticationState } from '../../@types/AuthenticationState';
import { OidcSigninState } from '../../@types/OidcSigninState';
import oidcConfig from '../../Configuration/OidcConfiguration';
import UserPanelButton from './UserPanelButton';

interface MenuItemSpec {
  key: string;
  targetUrl: string;
  text: string;
  onClickHandler: React.MouseEventHandler<HTMLAnchorElement>
  icon?: propTypes.ReactElementLike

}


const UserPanel: FC = () => {

  const auth = useAuth();

  const [anchorElNav, setAnchorElNav] = useState<EventTarget | any>(null);
  const [authenticationState, setAuthenticationState] = useState<AuthenticationState | null>(null);
  const handleOpenNavMenu = (event: React.SyntheticEvent<EventTarget>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const performSignOut = async () => {
    handleCloseNavMenu();
    console.info("Performing sign out")
    console.info(window.location.origin)
    await auth.signoutRedirect({
      extraQueryParams: {
        client_id: oidcConfig.client_id,
        redirect_uri: oidcConfig.redirect_uri,
        logout_uri: `${window.location.origin}`,
        response_type: oidcConfig.response_type ?? '',
      },
    });
  }

  const performSignIn = () => {
    handleCloseNavMenu();
    const state: OidcSigninState = {
      targetUrl: window.location.pathname
    }
    auth.signinRedirect({
      state: state
    });
  }

  const getAuthenticatedMenuItems = (): Array<MenuItemSpec> => {
    return [
      {
        key: 'signout',
        onClickHandler: performSignOut,
        targetUrl: '',
        text: 'Logga ut',
        icon: <LogoutIcon />
      }]
  }

  useEffect(() => {
    if (auth) {
      setAuthenticationState({
        isAuthenticated: auth?.isAuthenticated ?? false,
        identity: {
          firstName: auth.user?.profile.given_name ?? '',
          lastName: auth.user?.profile.family_name ?? '',
          email: auth.user?.profile.email ?? '',
          id: auth.user?.profile.sub ?? ''
        }
      })
    }
  }, [auth])


  return (
    <>
      <UserPanelButton authenticationState={authenticationState} menuOpenHandler={handleOpenNavMenu} />
      <Menu
        id="menu-userpanel"
        anchorEl={anchorElNav}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        className='app-menu-root'
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElNav)}
        onClose={handleCloseNavMenu}
        sx={{
          display: { xs: 'block' },
        }}
      >
        {
          (auth?.isAuthenticated && auth.user)
            ? (
              getAuthenticatedMenuItems().map(x => (
                <MenuItem
                  key={x.key}
                  onClick={x.onClickHandler}
                  component={Link}
                  to={x.targetUrl}
                >
                  <>{x.icon}<Box sx={styles.menuText}>{x.text}</Box></>
                </MenuItem>
              ))
            ) : (

              <MenuItem
                key='signin'
                onClick={performSignIn}
                component={Link}
                to={''}
              >
                <><LoginIcon /><Box sx={styles.menuText}>Logga in</Box></>
              </MenuItem>
            )
        }
      </Menu>
    </>

  )

};
export default UserPanel


const styles: Record<string, SxProps<Theme>> = {
  menuText: {
    display: 'inline',
    marginLeft: '0.5rem',
  },

}
